module.exports = __webpack_public_path__ + "img/remove.5f61d6b6.webp";